import styles from './controlGroup.module.css'

interface Props {
  title?: string
  children: JSX.Element
}

export default function ControlGroup({children, title}: Props) {
  return (
    <div className={styles.controlGroup}>
      {title && <span className={'groupTitle'}>{title}</span>}
      <div className={styles.controlWrapper}>{children}</div>
    </div>
  )
}
